import { render, staticRenderFns } from "./user-password-manage.vue?vue&type=template&id=99e523e2&scoped=true&"
import script from "./user-password-manage.vue?vue&type=script&lang=js&"
export * from "./user-password-manage.vue?vue&type=script&lang=js&"
import style0 from "./user-password-manage.vue?vue&type=style&index=0&id=99e523e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e523e2",
  null
  
)

export default component.exports